export async function getDbLngKey(lngKey) {
  let lng = lngKey.toLowerCase();

  if(lng === 'de' || lng === 'deu')
    return 'deu';

  if(lng === 'it' || lng === 'ita')
    return 'ita';

  if(lng === 'en' || lng === 'eng')
    return 'eng';

  return 'deu';
}



export function getNameForSessionAndStore(nameType) {

    let p = window.location.href;

    //console.log('p value ...', p);


    let urlType = 0;
    if(p.indexOf('localhost') > -1) {
        //localhost for development
        urlType = 1;
        p = ('localhost');
    } else if (p.indexOf('teamware.cloud') > -1) {
        //a teamware sub-url ... only the first sub-path will be supported
        urlType = 2;

        p = window.location.origin;
        const firstPath = window.location.pathname.split('/')[1];
        p = p.concat('/').concat(firstPath);
    } else {
        //a customer specific domain will be used
        urlType = 3;

        p = window.location.origin;        
    };

    p = p.concat('_').concat(nameType);

    //console.log(nameType, 'value => ', p, 'urlType', urlType);
    return p;

}


export function getMonthFullName(monthAsNumber, language) {

  let month = 0;
  let lng = 'en';

  let monthsDE = [
    'Jänner',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];

  let monthsIT = [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ];

  let monthsEN = [    
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];



  if(monthAsNumber !== undefined && monthAsNumber !== 0 && monthAsNumber !== '' && isNaN(monthAsNumber) === false )
    month = monthAsNumber;

  if(month < 1 )
    month = 1;

  if(month > 12 )
    month = 12;

  if(language !== undefined && language !== null && language.length >= 2)
    lng = language.substring(0, 2).toLowerCase();



  if(lng === 'de') {
    return monthsDE[month - 1];
  }
  else if(lng === 'it') {
    return monthsIT[month - 1];
  }
  else if(lng === 'en') {
    return monthsEN[month - 1];
  }

}